$(document).ready(function () {
	let selectGamme = $('.models_list').data('active-gamme') ?? 'kia';
	console.log(`selected gamme : ${selectGamme}`);

	if (selectGamme) {
		$('.gamme_model').removeClass('active');
		$('.gamme_model--picture').removeClass('active');
		$('.gamme_list li>a').removeClass('active');
		$('.gamme_list').removeClass('active');
		$(`.models_list--logo a`).removeClass('active');

		$(`.gamme_list[data-gamme="${selectGamme}"]`).addClass('active');
		$(`.gamme_list[data-gamme="${selectGamme}"] li>a`)
			.first()
			.trigger('click')
			.addClass('active');
		$(`.models_list--logo a[data-gamme="${selectGamme}"]`).addClass('active');
	}
	$('.gammes_logo_item').first().addClass('active');

	const garageAchat = $('#garage-achat');
	const garageEntretien = $('#garage-entretien');

	$('.gammes_logo_item').on('click', function (e) {
		e.preventDefault();
		$('.gammes_logo_item').removeClass('active');
		$(this).addClass('active');
	});

	$('.gammes_logo_item').on('click', function (e) {
		console.log($(this));
		selectGamme = $(this).find('a').attr('data-marque');

		console.log($(this));
		console.log(selectGamme);
		$('.gammes_logo_item').removeClass('active');
		$(this).addClass('active');
	});

	$('.models_list--logo a').on('click', function (e) {
		selectGamme = $(this).attr('data-gamme');

		if (selectGamme == 'suzuki' || selectGamme == 'isuzu') {
			garageAchat.find(':nth-child(-n+4)').not(':first-of-type').hide();
			garageEntretien.find(':nth-child(-n+4)').not(':first-of-type').hide();
		} else {
			garageAchat.find(':nth-child(-n+4)').not(':first-of-type').show();
			garageEntretien.find(':nth-child(-n+4)').not(':first-of-type').show();
		}

		$('ul#items-' + selectGamme)
			.find('li a')
			.first()
			.trigger('click');
	});

	$('.gammes_item_marque').on('click', function (e) {
		e.preventDefault();

		const marque = $(this).attr('data-marque');
		$('.modeles').slideUp();
		$('#modeles-' + marque).slideDown();
		$('#modeles-' + marque)
			.find('.gamme_list.active li>a')
			.trigger('click')
			.addClass('active');
	});
});
